define('get-tasks-answers',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var getOptions = function getOptions(entity, answers) {

        switch (entity.typeId) {
            case 12:
                // Open question

                return entity.answers.length ? answers.map(function (uAnswer) {
                    return entity.answers.filter(function (o) {
                        return o.id === uAnswer.answerId;
                    }).reduce(function (res, o) {
                        return Object.assign(res, {
                            orderNum: o.orderNum,
                            text: o.text,
                            answerText: uAnswer.answerText
                        });
                    }, {});
                }) : answers.map(function (answer) {
                    return { answerText: answer.answerText };
                });

            case 13:
                // Multiple question

                return answers.map(function (uAnswer) {
                    return entity.answers.filter(function (o) {
                        return o.id === uAnswer.answerId;
                    }).reduce(function (res, o) {
                        return Object.assign(res, {
                            answerText: entity.contentEntity.freeTextAnswerId === uAnswer.answerId ? uAnswer.answerText : o.text,
                            orderNum: o.orderNum
                        });
                    }, {});
                });
            case 17:
                // Evaluate

                return answers.map(function (uAnswer) {
                    var answer = entity.answers.filter(function (o) {
                        return o.id === uAnswer.answerId;
                    }).reduce(function (res, o) {
                        return Object.assign(res, o);
                    }, {});

                    var question = entity.questions.filter(function (o) {
                        return o.id === uAnswer.questionId;
                    }).reduce(function (res, o) {
                        return Object.assign(res, o);
                    }, {});

                    return {
                        text: question.text,
                        answerText: answer && answer.text ? answer.text : '',
                        orderNum: answer && answer.orderNum ? answer.orderNum : ''
                    };
                });
            default:
                return [];
        }
    };

    var getQuestion = function getQuestion(entity) {
        switch (entity.typeId) {
            case 12:
            case 13:
                return entity.questions.length ? entity.questions[0].text : '';
            case 17:
                return '';
            default:
                return 'Warning! Question for type ' + entity.typeId + ' has not been implemented';
        }
    };

    exports.default = function (arr) {

        var res = arr.filter(function (o) {
            return o.entity.typeId !== 10 && o.entity.typeId !== 19;
        }).map(function (o) {
            return {
                'componentsKinds': o.entity.contentEntity.components.map(function (o) {
                    return o.kind;
                }),
                'contentEntityId': o.entity.contentEntityId,
                'options': getOptions(o.entity, o.answers).sort(function (a, b) {
                    return a.orderNum - b.orderNum;
                }),
                'question': getQuestion(o.entity),
                'title': o.entity.contentEntity.name,
                'typeId': o.entity.typeId
            };
        });

        return res;
    };
});
